import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { Currency } from "../../../../../../models/currency";
import { EstimateGroup, EstimateService } from "../../../../../../models/estimate";
import { ChargeOptionsEnum, ChargeOptions } from "../../../../../../models/service";
import { TotalItemValues } from "../../../../../../util/inventory";
import {
  calculateSubtotalByChargeAndByEstimate,
  formatCurrency,
} from "../../../../../../util/prices";
import {
  Wrapper,
  WrapperService,
  HeaderService,
  WrapperRightHeader,
  HeaderText,
  List,
  ListItem,
  Icon,
} from "./styled";

interface GroupSectionProps {
  group: EstimateGroup;
  isEstimateMode?: boolean;
  allCurrencies: Currency[];
  totalInventoryVolume?: TotalItemValues;
}

export const ServiceSectionMobile = (props: GroupSectionProps) => {
  const { group, totalInventoryVolume, isEstimateMode } = props;
  const { t: translate } = useTranslation();

  const [expandService, setExpandService] = useState<boolean[]>([]);

  const onExpandService = (index: number) => {
    const expandArray = [...expandService];

    expandArray[index] = !expandArray[index];

    setExpandService(expandArray);
  };

  const renderArrowToExpand = (index: number) => {
    const ServiceArrowExpanded = Icon(expandService[index]);

    return <ServiceArrowExpanded onClick={() => onExpandService(index)} />;
  };

  const renderQuantityValue = (service: EstimateService) => {
    if (service.charge === ChargeOptionsEnum.Fee && isEstimateMode)
      return totalInventoryVolume?.volumeFormatted;

    return service.quantity;
  };

  const renderSubtotalValue = (service: EstimateService) => {
    const subtotal = calculateSubtotalByChargeAndByEstimate(
      service.charge as keyof ChargeOptions,
      service.rate,
      service.quantity,
      service.discount,
      service.margin,
      service.markUp,
      totalInventoryVolume?.volumeConverted
    );

    return formatCurrency(subtotal, service.currency);
  };

  useEffect(() => {
    if (group?.estimateServices?.length) {
      const len = group.estimateServices?.length;
      const expandedArray: boolean[] = new Array(len).fill(true);

      setExpandService(expandedArray);
    }
  }, [group.estimateServices]);

  return (
    <Wrapper>
      {group.estimateServices?.map((service, index: number) => (
        <WrapperService key={service.id}>
          <HeaderService isExpanded={expandService[index]}>
            <HeaderText>{service.name}</HeaderText>
            <WrapperRightHeader>
              <HeaderText>
                {service.currency?.code} {renderSubtotalValue(service)}
              </HeaderText>
              {renderArrowToExpand(index)}
            </WrapperRightHeader>
          </HeaderService>

          {expandService[index] && (
            <List>
              <ListItem>
                <span>{translate("charge")}</span>
                <span>{service.charge}</span>
              </ListItem>
              <ListItem>
                <span>{translate("quantity")}</span>
                <span>{renderQuantityValue(service)}</span>
              </ListItem>
              <ListItem>
                <span>{translate("currency")}</span>
                <span>{service.currency?.name}</span>
              </ListItem>
            </List>
          )}
        </WrapperService>
      ))}
    </Wrapper>
  );
};
